/**
 * Tool calls that speak to the merchant rather than report work. They are
 * never work-log steps; each renders as its own item in the conversation.
 *
 * A question (`request-user-input`, answered on its card) is one in every
 * chat. A surface adds its own through `MessageFlags.conversationTools` and
 * draws them through the `toolCard` slot.
 */
export const isConversationTool = (
  toolName: string,
  conversationTools: readonly string[] | undefined
): boolean =>
  toolName === "request-user-input" ||
  Boolean(conversationTools?.includes(toolName));

/**
 * Whether a tool call is a work-log step: any tool that reports work, plus a
 * question while Atlas is still writing it (ENG-7894). "Generating a question
 * for you…" is work in progress and belongs in the task list with the rest;
 * once the question exists it is the merchant's, asked on its card, and it
 * leaves the log.
 */
export const isWorkLogToolCall = (
  part: { toolName: string; state: string },
  conversationTools: readonly string[] | undefined
): boolean =>
  !isConversationTool(part.toolName, conversationTools) ||
  (part.toolName === "request-user-input" &&
    (part.state === "input-streaming" || part.state === "input-available"));
